<template>
  <div>
    <cx-padding
      :paddingTypeFlag.sync="edgeType"
      :padding.sync="gridEdge"
      :paddingTop.sync="gridEdgeTop"
      :paddingRight.sync="gridEdgeRight"
      :paddingBottom.sync="gridEdgeBottom"
      :paddingLeft.sync="gridEdgeLeft"
      :sliderMax="150"
    />
    <!--    <label>内边距</label>-->
    <!--    <div class="grid-type-btn floatRight mb16">-->
    <!--      <el-tooltip class="item" effect="dark" content="全部内边距" placement="top-end" :open-delay="1000">-->
    <!--        <span-->
    <!--          class="icon-portal-padding-around pointer"-->
    <!--          :class="edgeType == 'global' ? 'select' : ''"-->
    <!--          @click="changeEdgeType('global')"-->
    <!--        ></span>-->
    <!--      </el-tooltip>-->
    <!--      <el-tooltip class="item" effect="dark" content="独立内边距" placement="top-end" :open-delay="1000">-->
    <!--        <span-->
    <!--          class="icon-portal-padding pointer"-->
    <!--          :class="edgeType == 'single' ? 'select' : ''"-->
    <!--          @click="changeEdgeType('single')"-->
    <!--        ></span>-->
    <!--      </el-tooltip>-->
    <!--    </div>-->
    <!--    &lt;!&ndash;    <div v-show="gridMode == '自定义'">&ndash;&gt;-->
    <!--    <div class="clearFloat" style="line-height: normal">-->
    <!--      <slider-and-input-->
    <!--        v-if="checkType(gridMode) && edgeType == 'global'"-->
    <!--        class="mt8"-->
    <!--        :value.sync="gridEdge"-->
    <!--        :sliderMax="200"-->
    <!--        suffix="px"-->
    <!--        inputWidth="small"-->
    <!--        inputHeight="small"-->
    <!--      />-->
    <!--      <div v-else>-->
    <!--        <slider-and-input-->
    <!--          v-if="checkType(gridEdgeLeft)"-->
    <!--          class="mt16"-->
    <!--          className="grid_edge_1"-->
    <!--          :value.sync="gridEdgeLeft"-->
    <!--          :sliderMax="200"-->
    <!--          :sliderMin="-10"-->
    <!--          suffix="px"-->
    <!--          inputWidth="small"-->
    <!--          inputHeight="small"-->
    <!--        />-->
    <!--        <slider-and-input-->
    <!--          v-if="checkType(gridEdgeTop)"-->
    <!--          className="grid_edge_2"-->
    <!--          class="mt16"-->
    <!--          :value.sync="gridEdgeTop"-->
    <!--          :sliderMax="200"-->
    <!--          :sliderMin="-10"-->
    <!--          suffix="px"-->
    <!--          inputWidth="small"-->
    <!--          inputHeight="small"-->
    <!--        />-->
    <!--        <slider-and-input-->
    <!--          v-if="checkType(gridEdgeRight)"-->
    <!--          className="grid_edge_3"-->
    <!--          class="mt16"-->
    <!--          :value.sync="gridEdgeRight"-->
    <!--          :sliderMax="200"-->
    <!--          :sliderMin="-10"-->
    <!--          suffix="px"-->
    <!--          inputWidth="small"-->
    <!--          inputHeight="small"-->
    <!--        />-->
    <!--        <slider-and-input-->
    <!--          v-if="checkType(gridEdgeBottom)"-->
    <!--          className="grid_edge_4"-->
    <!--          class="mt16"-->
    <!--          :value.sync="gridEdgeBottom"-->
    <!--          :sliderMax="200"-->
    <!--          :sliderMin="-10"-->
    <!--          suffix="px"-->
    <!--          inputWidth="small"-->
    <!--          inputHeight="small"-->
    <!--        />-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import publicData from "./publicData"
export default {
  mixins: [publicData],
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      this1: this
    }
  },
  methods: {
    // 修改边距类型
    changeGridTypeFunc(value) {
      this.$changeOptionsEV(value, "chartOption.grid.mode", false)
      if (value == "默认") {
        this.gridEdge = 30
      }
    },
    changeEdgeType(val) {
      this.edgeType = val
    }
  },
  computed: {
    chartOpt() {
      return this.options.chartOption
    },
    edgeType: {
      get() {
        let type = this.hasProperty(this.chartOpt, "grid.edgeType")
        if (typeof type === "string") {
          return type === "global" ? 2 : 1
        }
        return this.hasProperty(this.chartOpt, "grid.edgeType")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.grid.edgeType", false)
      }
    },
    gridMode: {
      get() {
        return this.hasProperty(this.chartOpt, "grid.mode")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.grid.mode", false)
      }
    },
    gridEdge: {
      get() {
        const data = this.hasProperty(this.chartOpt, "grid") //获取数据
        const dataMap = ["top", "left", "right", "bottom"] //过滤工具数组
        return (
          data &&
          parseInt(
            dataMap.reduce((prevK, currK, currKIndex) => {
              if (currKIndex - 1 === 0) {
                return Number(data[prevK]) + Number(data[currK])
              } else {
                return prevK + Number(data[currK])
              }
            }) / dataMap.length
          )
        )
      },
      set(newVal) {
        const grid = {
          top: Number(newVal),
          left: Number(newVal),
          right: Number(newVal),
          bottom: Number(newVal)
        }
        Object.keys(grid).forEach(k => {
          this.$changeOptionsEV(grid[k], `chartOption.grid.${k}`, false)
        })
      }
    },
    gridEdgeLeft: {
      get() {
        return this.hasProperty(this.chartOpt, "grid.left")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.grid.left", false)
      }
    },
    gridEdgeTop: {
      get() {
        return this.hasProperty(this.chartOpt, "grid.top")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.grid.top", false)
      }
    },
    gridEdgeRight: {
      get() {
        return this.hasProperty(this.chartOpt, "grid.right")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.grid.right", false)
      }
    },
    gridEdgeBottom: {
      get() {
        return this.hasProperty(this.chartOpt, "grid.bottom")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.grid.bottom", false)
      }
    }
  }
}
</script>

<style scoped>
.clearFloat {
  clear: both;
}
.grid-type-btn {
  line-height: 26px;
}
</style>
